import React, { Component } from 'react';
import { NavLink, Route, Switch } from 'react-router-dom';
import { connect } from 'react-redux';
import cn from 'classnames';
import Footer from 'components/Footer';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { uploadLogo, loadCompany, updateCompany } from 'actions/profile';
import Sticky from 'react-sticky-el';
import { ROOT_URL } from 'constants/Config';
import styles from './styles.scss';
import Avatar from './Avatar/Avatar';
import Social from './Social';
import EmployersList from './EmployersList';
import SubscriptionBar from 'components/Payments/SubscriptionBar';
import AvatarUploader from './AvatarUploader';
import { setPopUp } from 'actions/environment';

import ProfileInput from './ProfileForm/Input';
import ProfileTextInput from './ProfileForm/Textarea';
import i18n from '../../i18n';
import { useTranslation, withTranslation } from 'react-i18next';
import { isTariffsEnabled } from './helpers';
import { gaEvent, trackGA } from 'services/ga';

const validate = values => {
  const errors = {};
  if (!values.name) {
    errors.name = i18n.t('components.profile.company.validate.name');
  } else if (values.name.length > 30) {
    errors.name = i18n.t('components.profile.company.validate.nameError');
  }
  if (isTariffsEnabled) {
    if (!values.inn || values.inn.length < 10 || values.inn.length > 12 || !values.inn) {
      errors.inn = i18n.t('components.profile.company.validate.inn');
    }
  }

  if (!values.kpp || values.kpp.length !== 9) {
    errors.kpp = i18n.t('components.profile.company.validate.kpp');
  }
  if (values.description && values.description.length > 500) {
    errors.description = i18n.t('components.profile.company.validate.description');
  }
  if (values.office && values.office.length) {
    const officeErrors = {};
    values.office.forEach((o, index) => {
      if (!o.name) {
        officeErrors.name = i18n.t('components.profile.company.validate.officeErrors1');
      } else if (o.name.length > 30) {
        officeErrors.name = i18n.t('components.profile.company.validate.officeErrors2');
      }
      if (!o.address) {
        officeErrors.address = i18n.t('components.profile.company.validate.address');
      }
      if (!o.phone) {
        officeErrors.phone = i18n.t('components.profile.company.validate.phone');
      }
      if (!o.mail) {
        officeErrors.mail = i18n.t('components.profile.company.validate.email');
      } else if (o.mail.length > 30) {
        officeErrors.mail = i18n.t('components.profile.company.validate.emailError');
      }
      if (officeErrors) {
        errors.office = errors.office || [];
        errors.office[index] = officeErrors;
      }
    });
  }

  return errors;
};

const Input = (props) => (
  <ProfileInput {...props} className={styles.InputWrapper} />
);

const OfficeInputs = ({ fields }) => {
  const { t } = useTranslation();
  return (
    <div>
      {
        fields.map(
          (ofc, i) => (
            <div className={styles.OfficeBlock} key={i}>
              <p className={styles.SectionTitle}>{i === 0 ? t('components.profile.company.mainOffice') : t('components.profile.company.anotherOffice')}</p>
              <Field name={`${ofc}.name`} component={Input} label={t('components.profile.company.officeName')} placeholder={t('components.profile.company.officeNamePlaceholder')} required />
              <Field name={`${ofc}.address`} component={Input} label={t('components.profile.company.officeAddress')} placeholder={t('components.profile.company.officeAddressPlaceholder')} required />
              <div className={styles.PairInputs}>
                <Field name={`${ofc}.phone`} component={Input} label={t('components.profile.company.officePhone')} placeholder="8 (800) 000 0000" required />
                <Field name={`${ofc}.mail`} component={Input} label={t('components.profile.company.officeEmail')} placeholder="welcome@mail.com" required />
              </div>
            </div>
          )
        )
      }
      <div className={styles.AddOfficeBtnWrap}>
        <div
          className={styles.AddOfficeBtn}
          onClick={() => { fields.push({}); }}
        >
          {t('components.profile.company.plusOffice')}
        </div>
      </div>
    </div>
  );
};

const TextInput = (props) => (
  <ProfileTextInput {...props} className={styles.TextareaWrapper} />
);

class Company extends Component {
  constructor(props) {
    super(props);

    this.state = {
      list: false
    };
  }

  componentDidMount() {
    trackGA(gaEvent.pageShow({
      screenName: this.props.location.pathname
    }));
  }

  UNSAFE_componentWillMount() {
    const { loadCompany } = this.props;

    loadCompany({});
  }

  onLoadPhoto = ({ preview, file }) => {
    const {
      uploadLogo, setPopUp
    } = this.props;
    setPopUp(
      <AvatarUploader
        file={file}
        preview={preview}
        onSave={(file) => {
          const data = new FormData();
          data.append('file', file);
          setPopUp();
          uploadLogo(data);
        }}
      />,
      { closeStyleName: 'Default', contentStyleName: 'Default', closeIcon: 'default', lockScroll: false });
  }

  render() {
    const { handleSubmit, updateCompany, initialValues, logoId, agencyId, match: { path }, profile, t }
      = this.props;

    return (
      <div className={cn(styles.ProfileCompanyWrap, { [styles.ProfileCompanyAdmin]: profile.roleId === '15' })}>
        <div className={styles.ProfileCompany}>
          {initialValues &&
          <div className={styles.Container}>
            <div className={styles.Title}>
              {t('components.profile.company.title')}
            </div>
            {profile.roleName === 'owner' && <SubscriptionBar className={styles.SubscriptionBar} />}
            <div className={styles.Inner}>
              <div className={styles.Nav}>
                <NavLink
                  exact
                  to="/company"
                  className={styles.NavLink}
                  activeClassName={styles.Active}
                >
                  {t('components.profile.company.commonInfo')}
                </NavLink>
                <NavLink
                  exact
                  to="/company/employees"
                  className={styles.NavLink}
                  activeClassName={styles.Active}
                >
                  {t('components.profile.company.workers')}
                </NavLink>
              </div>

              <Switch>
                <Route
                  exact
                  path={`${path}/employees`}
                  component={EmployersList}
                />
                <Route
                  exact
                  path={`${path}`}
                  render={() =>
                    <form
                      className={styles.InnerContent}
                      onSubmit={handleSubmit(props => updateCompany({ ...props, logoId, agencyId }))}
                    >
                      <div className={styles.AvatarWrap}>
                        <Avatar
                          src={logoId ? `${ROOT_URL}/image/get?id=${logoId}&preset=avatar_edit` : null}
                          onLoadPhoto={this.onLoadPhoto}
                        />
                      </div>
                      <div className={styles.InputsWrap}>
                        <Field
                          name="name"
                          component={Input}
                          label={t('components.profile.company.form.name')}
                          placeholder="Leto Realty"
                          id="company-name"
                          required
                          disabled
                        />
                        <Field
                          name="website"
                          component={Input}
                          label={t('components.profile.company.form.website')}
                          placeholder="www.web-site.com"
                          id="website"
                        />
                        <Field
                          name="description"
                          component={TextInput}
                          label={t('components.profile.company.form.description')}
                          placeholder={t('components.profile.company.form.description')} id="description"
                          maxLength={500}
                        />

                        {isTariffsEnabled && (
                          <div className={styles.Columns}>
                            <div>
                              <Field
                                name="inn"
                                type="number"
                                component={Input}
                                label={t('components.profile.company.form.inn')}
                                inputProps={{
                                  maxLength: 12,
                                  inputType: 'number'
                                }}
                                placeholder=""
                                id="inn"
                                required
                              />
                            </div>
                            <div>
                              <Field
                                name="kpp"
                                component={Input}
                                label={t('components.profile.company.form.kpp')}
                                inputProps={{
                                  maxLength: 9,
                                  inputType: 'number'
                                }}
                                placeholder=""
                                id="kpp"
                                required
                              />
                            </div>
                          </div>
                        )}

                        <FieldArray name="office" component={OfficeInputs} />

                        <div className={styles.SectionSocial}>
                          <p className={styles.SectionTitle}>
                            {t('components.profile.company.socialNets')}
                          </p>
                          <Social />
                        </div>

                        <Sticky mode="bottom" stickyClassName={styles.SaveButtonWrapSticky} className={styles.SaveButtonWrap}>
                          <button className={cn(styles.Button, styles.ButtonSave, 'button-primary', 'button-primary--lg')}>
                            {t('components.profile.company.save')}
                          </button>
                        </Sticky>
                      </div>
                    </form>
                    }
                />
              </Switch>
            </div>
          </div>
          }
        </div>
        <Footer />
      </div>
    );
  }
}

export default Company = connect(
  ({ company, profile, profiles }) => {
    const res = {
      initialValues: undefined,
      logoId: company.data && company.data.logoId,
      agencyId: company.data && company.data.id,
      loading: company.loading,
      profile,
      workersCount: profiles.data ? profiles.data.length : 0
    };

    if (company.loading) {
      return res;
    }
    return {
      ...res,
      initialValues: company.data
    };
  },
  { uploadLogo, loadCompany, updateCompany, setPopUp }
)(
  reduxForm({
    form: 'CompanyForm',
    validate
  })(withTranslation()(Company))
);



// WEBPACK FOOTER //
// ./src/components/Profile/Company.js